import { cn } from "@/lib/utils";
export function WilsonFace({
  variant = "tile",
  className,
  title
}: {
  variant?: "tile" | "bare";
  className?: string;
  title?: string;
}) {
  const a11y = title ? {
    role: "img" as const,
    "aria-label": title
  } : {
    "aria-hidden": true
  }; // boolean-naming-exempt: external contract — ARIA attribute

  if (variant === "bare") {
    return <svg viewBox="0 0 35 32" fill="currentColor" className={cn("h-4 w-auto shrink-0", className)} {...a11y}>
                <path d="M17.22 31.56C11.245 31.56 5.455 30.43 0 28.21L1.23499 25.395C6.29499 27.46 11.675 28.505 17.22 28.505C22.765 28.505 28.145 27.46 33.205 25.395L34.44 28.21C28.985 30.43 23.195 31.56 17.22 31.56Z" />
                <path d="M18.6752 0H21.9503L15.0352 20.535H11.7603L18.6752 0Z" />
                <path d="M31.8202 0H28.6501V11.035H31.8202V0Z" />
                <path d="M5.80035 0H2.63037V11.035H5.80035V0Z" />
            </svg>;
  }
  return <svg viewBox="0 0 51 51" className={cn("h-8 w-8 shrink-0", className)} {...a11y} data-sentry-element="svg" data-sentry-component="WilsonFace" data-sentry-source-file="WilsonFace.tsx">
            <path d="M50.16 0H0V50.16H50.16V0Z" className="fill-ink" data-sentry-element="path" data-sentry-source-file="WilsonFace.tsx" />
            <path className="fill-surface" d="M34.73 12H37.355V21.14H34.73V12ZM26.465 12H29.18L23.455 29.01H20.74L26.465 12ZM13.175 12H15.8V21.14H13.175V12ZM25.265 38.14C20.315 38.14 15.52 37.205 11 35.365L12.025 33.035C16.22 34.745 20.675 35.61 25.265 35.61C29.855 35.61 34.31 34.745 38.505 33.035L39.53 35.365C35.01 37.205 30.215 38.14 25.265 38.14Z" data-sentry-element="path" data-sentry-source-file="WilsonFace.tsx" />
        </svg>;
}